import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import axios from '../../axiosConfig';
import { endpoints } from '../../utils/constants';
import { sendLogger } from '../../utils/loggerUtils';

export const postLogger = createAsyncThunk('api/postLogger', async (body, {dispatch}) => {
    try {
      const response = await axios.post(endpoints.LOGGER, body);
      return response.data;
    } catch (error) {
        const errMsg = 'Error sending log: ' + error;
        sendLogger(dispatch, errMsg, LogLevels.ERROR)
        console.error(errMsg);
      throw error;
    }
});

const loggerSlice = createSlice({
    name: 'logger',
    initialState: {
      data: [],
      loading: false,
      error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(postLogger.pending, (state) => {
          state.loading = true;
        })
        .addCase(postLogger.fulfilled, (state, action) => {
          state.loading = false;
          state.data = action.payload;
        })
        .addCase(postLogger.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
        });
    },
  });
  
  export default loggerSlice.reducer;